import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../../lib/api-client';
import { ActionRequiredOrdersResult } from '../types/ActionRequiredOrdersResult';

export const useGetActionRequiredOrders = (actionRequiredID?: number,
    pastDueOnly?: boolean, activeOnly?: boolean) => {
    const { data, isLoading } = useQuery({
        queryKey: ['dealer-action-required-orders', actionRequiredID, pastDueOnly, activeOnly],
        queryFn: async () => await apiClient.get('action-required/dealer-orders',
            {
                params: {
                    actionRequiredID: actionRequiredID,
                    pastDueOnly: pastDueOnly,
                    activeOnly: activeOnly
                }
            }) as ActionRequiredOrdersResult
    });

    return {
        data,
        isLoading
    };
};
